import { cn } from '../../lib/cn';
import { Badge } from './badge';

const statusStyles: Record<string, string> = {
  active: 'bg-emerald-100 text-emerald-800',
  pending_activation: 'bg-amber-100 text-amber-800',
  revoked: 'bg-rose-100 text-rose-800',
  open: 'bg-red-100 text-red-700',
  in_progress: 'bg-amber-100 text-amber-800',
  closed: 'bg-emerald-100 text-emerald-800',
};

export function StatusPill({ className, status }: { className?: string; status: string }) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        'w-fit justify-self-start rounded-full border-0 px-2 py-0.5 text-[11px] font-medium capitalize',
        statusStyles[status] ?? 'bg-slate-100 text-slate-700',
        className
      )}
    >
      {status.replace(/_/g, ' ')}
    </Badge>
  );
}
